import React, { useState } from 'react';

/**
 * Modal prompting for a single mandatory reason/note before a state-changing
 * action (reject, suspend, revoke, remove). Replaces the inline
 * textarea-under-the-row pattern several admin/partner pages used to repeat.
 */
export default function ReasonModal({ title, label, confirmLabel = 'Confirm', onConfirm, onClose, busy = false }) {
  const [reason, setReason] = useState('');

  const submit = () => {
    const trimmed = reason.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
  };

  return (
    <div className="modal-backdrop" onClick={() => !busy && onClose()}>
      <div className="modal-panel" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose} disabled={busy}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-row">
            <label>
              {label} <span style={{ color: 'var(--status-danger-fg)' }}>*</span>
            </label>
            <textarea
              className="form-input"
              rows={3}
              maxLength={500}
              autoFocus
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              style={{ width: '100%', boxSizing: 'border-box' }}
            />
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, marginTop: 16 }}>
            <button className="btn-secondary" onClick={onClose} disabled={busy}>Cancel</button>
            <button className="btn-primary" onClick={submit} disabled={busy || !reason.trim()}>
              {busy ? 'Processing…' : confirmLabel}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
